import { Component, AfterViewInit, Inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
// import { BroadcastService, MsalService } from '@azure/msal-angular';
import * as config from '../assets/config/config.json';
declare var jQuery: any;
import { AuthService } from './Shared/Services/auth.service'
import { logging } from 'protractor';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ConfigLoaderService } from './Shared/Services/Config/config-loader.service'
import { UserService } from './Shared/Services/user.service'
import { Location } from '@angular/common';
import { ErrorServiceService } from './Shared/Services/Error/error-service.service'
import { ErrorModel } from './Shared/Model/error/error-model';
// import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { userRole } from './Shared/Model/enum';
import { AdminService } from './Shared/Services/Admin/admin.service';
import $ from 'jquery';

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { EventType, EventMessage, AccountInfo, AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
// import { escapeRegExp } from '@angular/compiler/src/util';
import * as AOS from 'aos';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class AppComponent {
  title = 'ASDPortal';
  headerFooter: boolean = false;
  loggedIn: boolean = false;
  preloader: boolean = false;

  name!: string;
  username!: string;

  subscription!: Subscription;
  tokenFailSubscription!: Subscription

  offlineurl!: string;
  offline!: string;
  errModal!: ErrorModel;
  UserRole!: string;

  isIframe = false;
  private readonly _destroying$ = new Subject<void>();
  private appInitialized = false;
  loginDisplay = false;
  showPortalUI = false;
  Domain: string = ConfigLoaderService.settings.IAAA.Domain.toString();


  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authservice: AuthService,
    private http: HttpClient,
    private _userService: UserService,
    private _error: ErrorServiceService,
    private _location: Location,
    private _adminService: AdminService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.errModal = new ErrorModel();
    this.offline = this._location.path().split("?")[0];

    this._location.subscribe((event: any): void => {

    })

    if (this.offline == "/offline") {


      ConfigLoaderService.settings.AppSettings.offlineSetting = this._location.path();
      ConfigLoaderService.settings.AppSettings.offlineURL = this._location.path().split("?")[1];
      sessionStorage.setItem("offline", this._location.path().split("?")[1]);
      ConfigLoaderService.settings.AppSettings.IsOfflineLogged = true
    }


  }

  ngOnInit() {

    const isDevelopment =
      ConfigLoaderService.settings.env.name?.toUpperCase() === 'DEVELOPMENT';

    // console.log("Environment:", ConfigLoaderService.settings.env.name);

    AOS.init();
    this.isIframe = window !== window.parent && !window.opener;

    this.errModal.MethodName = "ngInit";
    this.errModal.ComponentName = "AppComponent";

    if (isDevelopment) {
      this.loginDisplay = true;
      this.preloader = false;
      this.headerFooter = true;
      return;
    }

    this.preloader = true;
    this.headerFooter = true;
    ConfigLoaderService.settings.AppSettings.showNotificationMessage = true;

    if (ConfigLoaderService.settings.AppSettings.ShowMaintainancePage?.toUpperCase() === "TRUE") {
      this.preloader = false;
      this.router.navigate(["/maintainance"]);
      return;
    }

    this.router.events
      .pipe(takeUntil(this._destroying$))
      .subscribe((event: any) => {

        if (event instanceof NavigationEnd) {

          this.headerFooter =
            event.url.split('?')[0] !== '/error';

        }
      });

    this.authservice.initializeAuth();
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) =>
            status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        // User not logged in
        if (!this.authenticated()) {
          this.loggingRedirect();
          return;
        }

        // User already logged in (refresh scenario)
        if (!this.appInitialized) {
          this.appInitialized = true;
          const accounts = this.msalService.instance.getAllAccounts();
          if (accounts.length > 0) {
            this.msalService.instance.setActiveAccount(accounts[0]);
          }
          this.setLoginDisplay();
        }
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        // console.log('Accounts', this.msalService.instance.getAllAccounts());
        // console.count('LOGIN_SUCCESS');

        if (this.appInitialized) {
          return;
        }

        this.appInitialized = true;
        const payload: any = result.payload as AuthenticationResult;
        // console.log("Payload",payload);
        this.msalService.instance.setActiveAccount(payload.account);
        ConfigLoaderService.settings.AppSettings.userId = payload['username'].split('@')[0];
        sessionStorage.setItem('userId',payload['username'].split('@')[0]);
        // console.log("User ID",ConfigLoaderService.settings.AppSettings.userId)
        this.setLoginDisplay();
      });
  }

  setLoginDisplay(): void {
    // console.count("setLoginDisplay");
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    if (!this.loginDisplay) {
      return;
    }
    this.authservice.getAccount();
    this.preloader = false;
    // this.gotoPages();
    // this.getTestSession();
    this.get1AAAPopup();
    this.getUserSession(
      ConfigLoaderService.settings.AppSettings.userId
    );
    $(window).on('beforeunload', () => {
      document.cookie =
        "oneAssetPopUpEnabled=; path=/; Domain=" +
        this.Domain +
        "; secure; SameSite=Lax";
    });
  }

  get1AAAPopup() {
    let DomainURL = ConfigLoaderService.settings.IAAA.DomainURL.toString();
    if (!document.referrer.startsWith(DomainURL)) {
      document.cookie = "oneAssetPopUpEnabled=; path=/; Domain=" + this.Domain + " ; secure; SameSite=Lax";
    }
    var tempassetOneCookie = this.getCookie('oneAssetPopUpEnabled');
    if (tempassetOneCookie == undefined || tempassetOneCookie == "") {
      tempassetOneCookie = "false"
    }
    var assetOneCookie = JSON.parse(tempassetOneCookie);
    var tempShowPopup = ConfigLoaderService.settings.IAAA.showPopUp;

    var showOneAssetPopup = (tempShowPopup == "true");

    if (!assetOneCookie && showOneAssetPopup) {
      var w = 610;
      var h = 568;
      var left = (screen.width - w) / 2;
      var top = (screen.height - h) / 4; // for 25%-divide by 4 | for 33%-divide by3 var popUp = window.open(myconcertoObj.config.OneAssetURL.toString(), 'Asset Usage Index Plugin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      var popUp = window.open(ConfigLoaderService.settings.IAAA.EnvURL, 'Asset Usage Index Plugin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      var closeTimer = setInterval(() => {
        if (popUp) {
          if (popUp.closed) {
            clearInterval(closeTimer);
            var now = new Date();
            var time = now.getTime();
            time += 3600 * 1000;
            now.setTime(time);
            document.cookie = "oneAssetPopUpEnabled=true;domain= " + this.Domain + ";path=/; secure; SameSite=Lax";
          }
        }
      }, 1000);
    }
  }


  getCookie(name: string) {
    // const value = document.cookie   
    // const result = value.split(`${name}=`)[1];
    // return result
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;

  }

  getTestSession() {
    const endpointUrl = ConfigLoaderService.settings.DevValues.endpointUrl;
    this.http.get(endpointUrl).subscribe(
      (result: any) => {
        if (result != null || result != "") {
          this.preloader = false;

        }
      },
      (err: any) => {
        // this._error.handleError(err, this.errModal);

      }
    )
  }

  getUserSession(userName: string) {
    let sesStorage!: any;
    this._userService.getUserSession(userName).subscribe(
      (res: any) => {
        sessionStorage.setItem("sessionStorage", res.toString())
        if (ConfigLoaderService.settings.env.name.toUpperCase() == "DEVELOPMENT") {
          this._userService.getToken(userName, res.toString()).subscribe(
            (res: any) => {

              this.preloader = false;
              sessionStorage.setItem("AccessToken", res["Token"])


            }
          )
        }
        else {
          this.preloader = false;
        }
        sesStorage = sessionStorage.getItem("sessionStorage")?.toString();
        this.getUserRole(userName, sesStorage)


      }
    )

  }

  getUserRole(userName: string, sessionId: string) {
    this._userService.getUserRole(userName, sessionId).subscribe(
      (res: any) => {
        var jsonData = JSON.stringify(res);
        const valueFromJson = JSON.parse(jsonData);
        let keys = Object.keys(valueFromJson);
        Object.getOwnPropertyNames(valueFromJson).forEach(key => {

          if (key == "Role") {
            this.UserRole = valueFromJson[key];

          }
        }
        )

      })
    this.getNotificaitonMessage();
  }

  getNotificaitonMessage() {

    this._adminService.selectNotificationMessage(ConfigLoaderService.settings.AppSettings.userId)
      .subscribe((data: any) => {

        ConfigLoaderService.settings.AppSettings.NotificationMessage = data;
      });


  }






  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  authenticated(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  loggingRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }



}
